module.exports = __webpack_public_path__ + "static/media/181IT246.bebecc1d.jpeg";